import { RootState } from '@app/redux/store';

export const getUserAutoList = (state: RootState) => state.autoUser.listAuto;
export const getIsLoadedListAuto = (state: RootState) => state.autoUser.isLoadedListAuto;
export const getErrorMessage = (state: RootState) => state.autoUser.errorMessage;
export const getIsErrorListAuto = (state: RootState) => state.autoUser.isError;
